// in the original Contentful SDK all properties are under the sys and fields keys, so we need to add these keys to the payload
function addFieldsToPayload(payload) {
  if (typeof payload !== 'object' || payload === null) {
    return payload
  }

  const fields = {}
  const sys = {
    // player uses entry ids to give elements unique keys/ids:
    id: payload?.id || '',
  }

  for (const key in payload) {
    if (Array.isArray(payload[key])) {
      fields[key] = payload[key].map(addFieldsToPayload)
      // remove empty arrays:
      if (fields[key].length === 0) {
        delete fields[key]
      }
    } else if (key === 'contentType') {
      // convoluted way to ensure player code can parse contentType from sys object as expected:
      sys.contentType = {
        sys: {
          id: payload[key].charAt(0).toLowerCase() + payload[key].slice(1),
        },
      }
    } else if (key === 'config') {
      // if key is config, it's a JSON object in an interactive that should not be recursively transformed
      fields[key] = payload[key]
    } else if (typeof payload[key] === 'object' && payload[key] !== null) {
      fields[key] = addFieldsToPayload(payload[key])
      if ('url' in payload[key]) {
        fields[key].fields = {
          ...fields[key].fields,
          file: {
            // the url field is more deeply nested in the Contentful SDK payload:
            url: payload[key].url,
          },
        }
      }
    } else {
      fields[key] = payload[key]
      if (key === 'text') {
        // for some reason Contentful function returns Text with a capitol T:
        fields.Text = payload[key]
      }
    }
  }

  return { fields, sys }
}

export function mapContentServiceToContentfulResponse(contentServiceResponse) {
  const { presentation } = contentServiceResponse
  const contentServiceStructure = structuredClone(presentation)
  const contentfulSdkStructure = addFieldsToPayload(contentServiceStructure)
  return contentfulSdkStructure
}
